import { Button, H6 } from "@sellar-io/components";
import { useForm } from "react-hook-form";
import { Alert } from "../../components/alert/Alert";
import { InputContainer } from "@sellar-io/components";
import { InputText } from "@sellar-io/components";
import {
  Dialog,
  DialogNavigation,
  DialogContent,
  DialogCTA,
} from "../../components/modal/Dialog";
import { apiV2AssertError } from "../../hooks/api/v2/apiV2Request";
import { useSupplierRelationshipUpdate } from "../../hooks/api/v2/supplierRelationship/useSupplierRelationshipUpdate";

export const CustomerUpdateInvoiceEmailModal = ({
  active,
  connectionId,
  invoiceEmails,
  onDismiss,
}: {
  active: boolean;
  onDismiss: () => void;
  connectionId: number;
  invoiceEmails: string[];
}) => {
  const { register, handleSubmit } = useForm({
    defaultValues: {
      emailArrayString: invoiceEmails.join(","),
    },
    shouldUseNativeValidation: true,
  });

  const updateConnectionMutation = useSupplierRelationshipUpdate(connectionId);

  return (
    <Dialog active={active} onDismiss={onDismiss}>
      <DialogNavigation
        title={"Update invoice emails"}
        description={"Add dedicated email addresses"}
        onClickLeftIcon={onDismiss}
        leftIcon={"CHEVRON_DOWN"}
      />
      <DialogContent className={"p-4"}>
        {updateConnectionMutation.isError && (
          <Alert
            type={"error"}
            message={
              apiV2AssertError(updateConnectionMutation.error)?.response?.data
                .message ?? "Unknown error"
            }
          />
        )}

        <form
          onSubmit={handleSubmit((data) => {
            const retailerInvoiceEmails = data.emailArrayString
              // Handling a number of suppliers that seem to use semi-colons
              .split(/[,;]/)
              .filter((email) => email.trim() !== "");

            updateConnectionMutation.mutate(
              {
                buyerInvoiceEmails: retailerInvoiceEmails,
              },
              {
                onSuccess: () => {
                  onDismiss();
                },
              },
            );
          })}
          className={"flex flex-col gap-2"}
        >
          <InputContainer>
            <InputText {...register("emailArrayString", { required: false })} />
          </InputContainer>
          <H6>To add multiple email addresses, seperate them with a comma</H6>
          <DialogCTA>
            <Button
              type={"submit"}
              loading={updateConnectionMutation.isPending}
            >
              Edit
            </Button>
          </DialogCTA>
        </form>
      </DialogContent>
    </Dialog>
  );
};
